import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { useRecoilValue } from 'recoil';

import { useSmartNavigate } from 'lib/hooks/useSmartNavigate';

import adminState from 'components/admin/lib/adminState';
import practiceState from 'components/practice/practiceState';
import state from 'components/state';

const PrivateRoutes = ({ type = '' }) => {
  const userState = useRecoilValue(state.userState);
  const practice = useRecoilValue(practiceState.currentPractice);
  const admin_state = useRecoilValue(adminState.current_admin);
  const location = useLocation();
  const { locationState } = useSmartNavigate();

  const redirectState =
    locationState === null
      ? {
          returnTo: location
        }
      : { returnTo: locationState?.returnTo };

  const redirectTo = () => {
    if (admin_state.logged_in) return '/admin';
    if (practice.id) return '/portal';
    if (userState.logged_in) return '/myportal';
    return '/login';
  };

  if (type === 'private') return <Navigate state={redirectState} to={redirectTo()} />;

  if (type === 'admin') {
    return admin_state.logged_in ? (
      <Outlet />
    ) : (
      <Navigate state={redirectState} to="/admin/login" />
    );
  }

  if (!userState.logged_in) return <Navigate state={redirectState} to="/login" />;

  if (type === 'portal')
    return !!practice.id ? <Outlet /> : <Navigate state={redirectState} to="/login" />;

  return <Outlet />;
};

export default PrivateRoutes;
